import React from 'react';

const SidenavOpenContext = React.createContext({
    sidenavOpen: true,
    setSidenavOpen: () => { }
})

export default SidenavOpenContext;